
    import Datetime from '../../admin/components/datetime'
    export default
        name: 'gc-table'
        components: {Datetime}
        props:
            format: {type: String, default: 'HH:mm:ss.SS'}
            races: {type: Object, default: {}}
            categories: {type: Array, default: []}
            teams: {type: Array, default: []}
            hideTeams: {type: Boolean, default: false}
            fieldsList:
                type: Array
                default: -> ['rank_abs', 'name', 'total_result']
        data: ->
            heats: general.heats || []
            filterCategory: null
            filter: {category: null, team: null, gender: null, keywords: null}
            gender_options: [{text: i18n.t('search.all'), value: null}, {text: 'M', value: 1}, {text: 'F', value: 2}]
            fields: [
                { key: 'rank_abs', label: i18n.t('ranks.abs'), class: 'text-center'},
                { key: 'rank_gender', label: i18n.t('ranks.gender'), class: 'text-center'},
                { key: 'rank_category', label: i18n.t('ranks.category'), class: 'text-center'},
                { key: 'name', label: i18n.t('name'), isRowHeader: true},
                { key: 'team', label: i18n.t('team')},
                { key: 'category', label: i18n.t('category'), class: 'text-center'},
                'races_dummy',
                { key: 'total_result', label: i18n.t('total'), class: 'text-center', isRowHeader: true}
            ]
            normalizedFields: []

        methods:
            head_slot: (key) -> "head(#{key})"
            cell_slot: (race_id) -> "cell(race_#{race_id})"
            myFilter: (item, filter) ->
#                item.category == filter
                isCategoryMatch = true
                isTeamMatch = true
                isGenderMatch = true
                isKeywordsMatch = true

                if filter.category != null
                  isCategoryMatch = item.category == filter.category

                if filter.team != null
                  isTeamMatch = item.team == filter.team

                if filter.gender != null
                  isGenderMatch = item.gender == filter.gender

                if filter.keywords
                  isKeywordsMatch = item.name.toLowerCase().includes(filter.keywords.toLowerCase())

                isCategoryMatch && isTeamMatch && isGenderMatch && isKeywordsMatch

        mounted: ->
            race_fields = Object.keys(@races).map (r) =>
                {key: "race_#{r}", label: @races[r], colType:'race', race_id: r}

            @fields.splice(@fields.indexOf('races_dummy'), 1, race_fields)
            if @hideTeams
              @fields = @fields.filter( (field) => field.key != 'team')
            if 0 == @categories.length
              @fields = @fields.filter( (field) => field.key != 'category')
              @fields = @fields.filter( (field) => field.key != 'rank_category')
            @normalizedFields = [].concat.apply([], @fields).filter (a) =>
                @fieldsList.includes(a.key) or 'race' == a.key.split('_')[0]

